import { render, staticRenderFns } from "./UsersManagement.vue?vue&type=template&id=4c977a40&scoped=true&"
import script from "./UsersManagement.vue?vue&type=script&lang=js&"
export * from "./UsersManagement.vue?vue&type=script&lang=js&"
import style0 from "./UsersManagement.vue?vue&type=style&index=0&id=4c977a40&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../Github/lmsv4_web_frontend_vue/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c977a40",
  null
  
)

export default component.exports